<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col sm="12" md="7" lg="9">
            <h3 tabindex="0">Consultar Formulários</h3>
          </b-col>
          <b-col sm="12" md="5" lg="3">
            <b-button @click="cadastrar" block variant="primary">
              <i class="fa fa-plus"></i>
              <span>Novo Formulário</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col sm="12" md="12" lg="6">
            <b-form-group label="Título do Formulário, ID:">
              <b-form-input type="text" id="name" v-model="filtros.filter" placeholder=""></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="6" lg="6">
            <b-form-group label="Situação:">
              <b-form-select v-model="filtros.situacao" placeholder="Situação" class="mb-3">
                <option selected :value="null">Selecione</option>
                <option v-for="item in situacoes" :key="item.id" :value="item.value"> {{ item.text }}</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" lg="6">
            <b-form-group label="Situação da inscrição:">
              <b-form-checkbox v-model="filtros.formulario_inscricao" :options="options"
                name="checkbox-validation">Formulário de Inscrição
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="4" lg="3" style="padding-bottom: 5px;">
            <b-button @click="limparFiltros()" block variant="primary">
              <span>Limpar Filtros</span>
            </b-button>
          </b-col>
          <b-col v-if="!loading" sm="12" md="4" lg="3">
            <b-button block variant="primary" @click="exportar">
              <i class="fa fa-file"></i>&nbsp;&nbsp;<span>Exportar</span>
            </b-button>
          </b-col>
          <b-col v-if="loading" sm="12" md="4" lg="3">
            <b-button block variant="primary" :disabled="true">
              <b-spinner small type="grow"></b-spinner>Exportando...</b-button>
          </b-col>
        </b-row>
      </b-card-body>
      <b-row>
        <b-col sm="12">
          <b-container fluid>
            <span>
              <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7"
                class="table table-responsive-sm table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th tabindex="0" scope="col" style="width: 10%">ID</th>
                    <th tabindex="0" scope="col" style="width: 30%">Título do Formulário</th>
                    <th tabindex="0" scope="col" style="width: 10%">Inscrição?</th>
                    <th tabindex="0" scope="col" style="width: 15%">Situação</th>
                    <th tabindex="0" scope="col" style="width: 20%">Ações</th>
                  </tr>
                </thead>
                <tbody v-if="formularios.data !== undefined">
                  <tr class="action" v-for="formulario in formularios.data" :key="formulario.id">
                    <td tabindex="0" style="width: 4%">{{ formulario.id }}</td>
                    <td tabindex="0" style="width: 28%">{{ formulario.titulo }}</td>
                    <td tabindex="0" style="width: 28%">{{ formulario.formulario_inscricao ? 'Sim' : 'Não' }}</td>
                    <td tabindex="0" style="width: 10%">{{ buscaSituacao(formulario.status) }}</td>
                    <td tabindex="0" style="width: 30%">
                      <b-button tabindex="0" class="btn btn-sm btn-secondary" title="Editar Formulário"
                        @click="editar(formulario.formulario_servico_id)">
                        <i class="fa fa-pencil-square-o"></i>
                      </b-button>

                      <b-dropdown id="dropdown-1" size="sm" class="m-1" no-flip>
                        <template v-slot:button-content>
                          <i class="fa fa-search"></i>
                        </template>

                        <b-dropdown-item @click="visualizar(formulario.formulario_servico_id)">Visualizar Formulário
                        </b-dropdown-item>

                        <b-dropdown-item @click="visualizarEstrutura(formulario.formulario_servico_id)">Visualizar
                          Estrutura
                        </b-dropdown-item>

                      </b-dropdown>
                      <b-button tabindex="0" class="btn btn-sm btn-secondary action" title="Excluir Formulário"
                        @click="modalExcluir(formulario)">
                        <i class="fa fa-times"></i>
                      </b-button>
                      <span>
                        <b-button tabindex="0" class="btn btn-sm btn-secondary action"
                          title="Atualizar Situação de Formulário" @click="modalAlterarSituacao(formulario)">
                          <i class="fa fa-toggle-on"></i>
                        </b-button>
                      </span>
                      <span>
                        <b-button tabindex="0" class="btn btn-sm btn-secondary action" title="Marcar como inscrição"
                          @click="marcarPadrao(formulario.id)">
                          <i class="fa fa-circle"></i>
                        </b-button>
                      </span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="action">
                    <td colspan="9" tabindex="0">Nenhum registro de formulário...</td>
                  </tr>
                </tbody>
              </table>
              <pagination tabindex="0" v-show="formularios.data !== undefined" :totalPorPagina="totalPorPagina"
                :resource="resource" :filtros="filtros"></pagination>
            </span>
          </b-container>
        </b-col>
      </b-row>
    </b-card>
    <b-modal title="Atualizar Situação de Formulário" :hide-footer="true" size="lg" v-model="modalSituacao">
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="3">
              <b-form-group tabindex="0" label="ID:">
                <b-input-group tabindex="0" class="mb-3">
                  <b-form-input type="text" class="form-control" placeholder="ID" v-model="dados.id" :disabled="true" />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="9">
              <b-form-group tabindex="0" label="Título do Formulário:">
                <b-input-group tabindex="0" class="mb-6">
                  <b-form-input id="titulo" type="text" :disabled="true" class="form-control" placeholder="Título"
                    v-model="dados.titulo" autofocus />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group tabindex="0" label="Situação:">
                <b-input-group tabindex="0" class="mb-3">
                  <b-form-input type="text" class="form-control" placeholder="Situação" v-model="dados.situacao"
                    :disabled="true" />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group tabindex="0" label="Situação Nova:">
                <b-form-select tabindex="0" v-model="novaSituacao" :state="chkState('novaSituacao')"
                  placeholder="Situação" class="mb-3">
                  <option selected :value="null">Selecione</option>
                  <option v-for="item in situacoes" :key="item.id" :value="item.value"> {{ item.text }}</option>
                </b-form-select>
                <b-form-invalid-feedback id="input1LiveFeedback3">Situação nova é obrigatória.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="novaSituacao == 'SU'">
            <b-col tabindex="0" cols="12">
              <p style="color: red"><strong>Atenção!</strong></p>
              <p>Ao <strong>Suspender</strong> o formulário de inscrição, ele não será mais exibido para que as pessoas
                possam realizar sua solicitação de inscrição na Conferência.</p>
              <p>Digite abaixo a mensagem de suspensão que será exibida quando os usuários tentarem se inscrever na
                Conferência.</p>
            </b-col>
            <br>
            <b-col cols="12">
              <b-form-group tabindex="0" label="Justificativa:">
                <b-form-textarea tabindex="0" id="textarea" maxlength="150" v-model="justificativa" rows="3"
                  max-rows="6"></b-form-textarea>
                <b-form-invalid-feedback tabindex="0" id="input1LiveFeedback3">Justificativa é
                  obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="8">
          </b-col>
          <b-col md="2">
            <b-button block variant="secondary" @click="fecharModal()">
              <span>Cancelar</span>
            </b-button>
          </b-col>
          <b-col md="2">
            <b-button block variant="primary" @click="modalAlterarSitucao()">
              <span>Salvar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-modal>
    <b-modal title="Excluir Formulário" ok-title="Excluir" cancel-title="Cancelar" v-model="modalExcluirFormulario"
      @ok="excluir()">
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="3">
              <b-form-group tabindex="0" label="ID:">
                <b-input-group tabindex="0" class="mb-3">
                  <b-form-input type="text" class="form-control" placeholder="ID" v-model="dados.id" :disabled="true" />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="9">
              <b-form-group tabindex="0" label="Título do Formulário:">
                <b-input-group tabindex="0" class="mb-6">
                  <b-form-input id="titulo" type="text" :disabled="true" class="form-control" placeholder="Título"
                    v-model="dados.titulo" autofocus />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group tabindex="0" label="Situação:">
                <b-input-group tabindex="0" class="mb-3">
                  <b-form-input type="text" class="form-control" placeholder="Situação" v-model="dados.situacao"
                    :disabled="true" />
                </b-input-group>
              </b-form-group>
            </b-col>
            <p tabindex="0">Tem certeza que deseja excluir o formulário? Ele será removido da base de dados do sistema e
              não será mais exibido.</p>
          </b-row>
        </b-form>
      </b-card-body>
    </b-modal>
  </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import { eventType } from '@/components/shared/eventType'
import { required, minLength, maxLength, email, sameAs, requiredIf } from 'vuelidate/lib/validators'
import { DatePicker, setupCalendar } from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'
import Multiselect from 'vue-multiselect'
import moment from 'moment'

setupCalendar({
  firstDayOfWeek: 2 // Monday
})

Vue.prototype.moment = moment
miniToastr.init()

export default {
  components: {
    Pagination,
    'v-date-picker': DatePicker,
    Multiselect
  },
  validations: {
    novaSituacao: {
      required
    }
  },
  created() {
    if (!this.validaPerfil()) {
      this.$router.push('/')
    }
  },
  data() {
    return {
      totalPorPagina: 10,
      resource: 'formulario',
      filtros: {
        filter: '',
        situacao: null,
        formulario_inscricao: false,
        user_id: SessionStorage.get('usuario')
      },
      loading: false,
      novaSituacao: null,
      justificativa: '',
      dados: [],
      solicitacoes: [],
      modalSituacao: false,
      modalExcluirFormulario: false,
      options: [
        { value: true }
      ],
      situacoes: [
        { value: 'RA', text: 'Rascunho' },
        { value: 'PU', text: 'Publicado' },
        { value: 'SU', text: 'Suspenso' },
        { value: 'FI', text: 'Finalizado' }
      ],
    }
  },
  computed: {
    formularios() {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    isValid() {
      return !this.$v.form.$anyError
    },
  },
  watch: {
    'filtros.filter': function () {
      this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
      this.setarFiltros(this.filtros)
    },
    'filtros.situacao': function () {
      this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
      this.setarFiltros(this.filtros)
    },
    'filtros.formulario_inscricao': function () {
      this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
      this.setarFiltros(this.filtros)
    }
  },
  methods: {
    buscaSituacao: function (situacao) {
      let descricao = ''

      switch (situacao) {
        case 'IN':
          descricao = 'Inativo'
          break;
        case 'AT':
          descricao = 'Ativo'
          break;
        case 'RA':
          descricao = 'Rascunho'
          break;
        case 'PU':
          descricao = 'Publicado'
          break;
        case 'SU':
          descricao = 'Suspenso'
          break;
        case 'FI':
          descricao = 'Finalizado'
          break;
      }
      return descricao
    },
    modalAlterarSituacao(formulario) {
      this.dados = []
      this.novaSituacao = null
      this.justificativa = ''
      this.dados.id = formulario.id
      this.dados.formulario_servico_id = formulario.formulario_servico_id
      this.dados.titulo = formulario.titulo
      this.dados.situacaoAntiga = formulario.status
      this.dados.situacao = this.buscaSituacao(formulario.status)

      if (formulario.justificativa !== '') {
        this.justificativa = formulario.justificativa
      }

      this.modalSituacao = true
    },
    modalExcluir(formulario) {

      this.dados.id = formulario.id
      this.dados.formulario_servico_id = formulario.formulario_servico_id
      this.dados.titulo = formulario.titulo
      this.dados.situacao = this.buscaSituacao(formulario.status)

      this.modalExcluirFormulario = true
    },
    visualizar(id) {
      Vue.http.get('api/formulario/visualizar/' + id).then(response => {
        if (response.body.success) {
          window.location.href = response.body.data[0]
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
        }
      })
    },
    marcarPadrao(id) {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja alterar este formulário para inscrição?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/formulario/alterarPadraoInscricao/' + id).then(response => {
            miniToastr.setIcon('success', 'i', { 'class': 'fa fa-success' })
            miniToastr.success(response.body.msg, 'Alerta!', 7000)

            this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
          }).catch(erro => { })
        }
      });
    },
    encaminhar(id) {
      Vue.http.get('api/formulario/encaminhar/' + id).then(response => {
        if (response.body.success) {
          window.location.href = response.body.data[0]
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
        }
      })
    },
    visualizarEstrutura(id) {
      Vue.http.get('api/formulario/visualizarEstrutura/' + id).then(response => {
        if (response.body.success) {
          window.location.href = response.body.data[0]
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
        }
      })
    },
    fecharModal() {
      this.modalSituacao = false
    },
    modalAlterarSitucao() {
      if (this.validate()) {
        this.$bvModal.msgBoxConfirm('Tem certeza que deseja alterar a situação do formulário?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        }).then(valor => {
          if (valor) {
            if (this.novaSituacao == 'SU' && this.justificativa == '') {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error('O campo Justificativa e obrigatorio.', 'Alerta!', 7000)
              $('#textarea').focus()
              return false
            }

            if (this.novaSituacao !== 'SU') {
              this.justificativa = ''
            }

            if (this.novaSituacao == this.dados.situacaoAntiga) {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error('O formulário já está com a situação escolhida.', 'Alerta!', 7000)
              return false
            }

            let data = {
              id: this.dados.formulario_servico_id,
              status: this.novaSituacao,
              justificativa: this.justificativa
            }

            this.modalSituacao = false

            Vue.http.post('api/formulario/alterarSituacao', data).then(response => {
              if (response.body.success) {
                miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
                miniToastr.success('Situação do formulário alterada com sucesso!', 'Sucesso!', 7000)
                this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
              }
            }).catch(erro => {
              if (!erro.body.success) {
                miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
                miniToastr.error('Erro ao alterar situação do formulário.', 'Alerta!', 7000)
              }
            })
          }
        }).catch(erro => {
          console.log(erro)
        })
      }
    },
    excluir() {
      Vue.http.get('api/formulario/excluir/' + this.dados.formulario_servico_id).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
          miniToastr.success('O registro foi excluído com sucesso.', 'Sucesso!', 7000)
          this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
        }
      }).catch(erro => {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error(erro.body.msg, 'Alerta!', 7000)
      })
    },
    exportarResposta(id, titulo) {
      Vue.http.get('api/formulario/exportarResposta/' + id).then(response => {
        if (response.body) {

          let valor = response.body.replaceAll(',', ';').replaceAll('<p>', ' ').replaceAll('</p>', ' ')

          let valorEncode = "\ufeff" + valor
          let blob = new Blob([valorEncode], { type: 'text/csv;charset=UTF-8;' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = titulo + '.csv'
          link.click()

          miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
          miniToastr.success('As respostas formulário foi exportado com sucesso.', 'Sucesso!', 7000)
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error('Erro ao exportar respostas do formulário.', 'Alerta!', 7000)
        }
      })
    },
    exportar() {
      this.loading = true
      const d = new Date();

      Vue.http.post('api/formulario/exportar', { filtros: this.filtros }, { responseType: 'blob' }).then(response => {
        if (response.ok) {
          let blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)

          let time = d.getTime();
          link.download = 'Formularios' + time + '.xlsx'
          link.click()
        }
        this.loading = false
      })
    },
    visualizarRespostas(id) {
      Vue.http.get('api/formulario/visualizarRespostas/' + id).then(response => {
        if (response.body.success) {
          window.location.href = response.body.data[0]
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
        }
      })
    },
    gerarPdf(id) {
      Vue.http.get('api/formulario/gerarPdf/' + id).then(response => {
        if (response.body.success) {
          window.open(response.body.data[0], '_blank');
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
        }
      })
    },
    cadastrar() {
      Vue.http.post('api/formulario/cadastrar').then(response => {
        if (response.body.success) {
          window.location.href = response.body.data[0]
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)

        }
      })
    },
    editar(id) {
      let data = {
        id: id
      }

      Vue.http.post('api/formulario/editar', data).then(response => {
        if (response.body.success) {
          console.log(response.body.data[0])
          window.location.href = response.body.data[0]
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)

        }
      })
    },
    duplicar(id) {
      this.$router.push('/formulario/' + id + '/duplicar')
    },
    validate() {
      let result = true

      if (!this.novaSituacao) {
        result = false
      }

      return result
    },
    chkState(val) {
      switch (val) {
        case 'novaSituacao':
          return !!this.novaSituacao
        default:
          return false
      }
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validaPerfil() {
      let perfil = this.$store.state.perfil.perfil
      if (perfil.is_admin_conferencia) {
        return true
      }
      return false
    },
    setarFiltros(filtros) {
      eventType.$emit('app', filtros)
    },
    limparFiltros() {
      this.filtros.filter = '';
      this.filtros.situacao = null;
    },
    navigate(route) {
      this.$router.push(route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/formularios/Formularios.vue